import { Component } from '@angular/core';

@Component({
  selector: 'app-not-allowed-container',
  templateUrl: './not-allowed-container.component.html',
  styleUrls: ['./not-allowed-container.component.scss'],
})
export class NotAllowedContainerComponent {}
